import { useInfiniteQuery, useQuery } from "react-query";
import { api } from "utils/api";
import type { OpenCallSearchRequest, OpenCallSearchResponse } from "../types";
import { openCallKeys } from "./queryKeys";

const getOpenCalls = (params: OpenCallSearchRequest) =>
  api.post<OpenCallSearchResponse>(`/open-call`, {
    body: JSON.stringify(params),
  });

const useOpenCalls = (params: OpenCallSearchRequest = {}) =>
  useQuery(openCallKeys.list(params), () => getOpenCalls(params));

const useOpenCallsWithPagination = (params: OpenCallSearchRequest = {}) =>
  useInfiniteQuery(
    openCallKeys.list(params),
    ({ pageParam }) => getOpenCalls({ searchAfter: pageParam, ...params }),
    {
      getNextPageParam: (lastPage) => lastPage.searchAfter,
    }
  );

export { useOpenCalls, useOpenCallsWithPagination };
